import { Container, Grid } from "@mui/material";
import { getQuestionRequest } from "api/requests";
import LoadingCM from "components/shared/Loading";
import MenuCM from "components/shared/menu";
import useHttp from "hooks/use-http";
import { useState } from "react";
import { useEffect } from "react";
import { MdOutlineExpandMore } from "react-icons/md";
import ContactCM from "components/contactus";
import {
  StyledAccordionDetail,
  StyledAccordionSummary,
  StyledAccordion,
  StyledContainer,
  StyledTitle,
} from "./CommonQuestion.style";
import FooterCM from "components/shared/footer";
import Card from "@mui/material/Card";
import {Helmet} from "react-helmet";

const CommonQuestion = () => {
  const { request, loading } = useHttp();
  const [questions, setQuestions] = useState([]);
  const getQuestions = async () => {
    const res = await request({ url: getQuestionRequest });
    setQuestions(res.data);
  };

  useEffect(() => {
    getQuestions();
  }, []);
  return (
    <>
      <Helmet>
        <title>پرسش های متداول - مبلمان ویول</title>
        <meta name="product_id" content={""} />
        <meta name="product_name" content={""} />
        <meta name="product_price" content={""} />
        <meta name="product_old_price" content={""} />
        <meta name="availability" content={""} />
        <meta property="og:image" content={""} />
      </Helmet>
      {loading ? (
        <LoadingCM />
      ) : (
        <>
          <MenuCM pageTitle="پرسش های متداول" />
          <Container>
            <Card
              sx={{
                marginTop: "30px",
                marginBottom: "30px",
                borderRadius: "15px",
              }}
            >
              <StyledContainer container pb={2}>
                <Grid item xs={12} mb={2} sx={{ padding: "0 !important" }}>
                  <StyledTitle>پرسش های متداول</StyledTitle>
                </Grid>
                {questions.map((items) => (
                  <Grid item mx={2} xs={12} key={"questoin" + items.id}>
                    <StyledAccordion TransitionProps={{ unmountOnExit: true }}>
                      <StyledAccordionSummary
                        expandIcon={<MdOutlineExpandMore size={22} />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        {items.question}
                      </StyledAccordionSummary>
                      <StyledAccordionDetail>
                        {items.answer}
                      </StyledAccordionDetail>
                    </StyledAccordion>
                  </Grid>
                ))}
              </StyledContainer>
            </Card>
          </Container>
          <ContactCM All />
          <FooterCM />
        </>
      )}
    </>
  );
};

export default CommonQuestion;
